import { Instant, LocalDateTime, ZoneId } from '@js-joda/core';
export const createEventState = () => ({
    id: null,
    title: '',
    description: '',
    location: '',
    startsAt: null,
    endsAt: null,
    eventType: 'meeting',
    eventStatus: 'active',
    tags: [],
    tabs: [],
});
const formatTime = (instant) => {
    const localTime = LocalDateTime.ofInstant(instant, ZoneId.SYSTEM).toLocalTime();
    const hour = localTime.hour();
    const minute = localTime.minute();
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    const displayMinute = minute.toString().padStart(2, '0');
    return `${displayHour}:${displayMinute} ${period}`;
};
export const formatTimeRange = (startsAt, endsAt) => {
    const start = formatTime(startsAt);
    if (!endsAt)
        return start;
    return `${start} - ${formatTime(endsAt)}`;
};
export const eventToShared = (event, badgeRenderer) => {
    return {
        id: event.id,
        title: event.title,
        start: new Date(event.startsAt.toEpochMilli()),
        end: new Date((event.endsAt || event.startsAt).toEpochMilli()),
        location: event.location,
        badges: badgeRenderer ? event.flags.map(badgeRenderer) : undefined,
        timeLabel: formatTimeRange(event.startsAt, event.endsAt),
        eventType: event.eventType,
    };
};
export const eventsToShared = (events, badgeRenderer) => {
    return events.map(e => eventToShared(e, badgeRenderer));
};
export const sharedEventToEvent = (event, id) => ({
    id: id,
    title: event.title,
    location: event.location || '',
    startsAt: Instant.parse(event.start.toISOString()),
    endsAt: Instant.parse(event.end.toISOString()),
    flags: [],
});
